import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SmartDeviceAccessService } from './service'

@NgModule({
  imports: [CommonModule],
  providers: [SmartDeviceAccessService],
})
export class SmartDeviceAccessStoreModule {}
